import { useCallback } from 'react';

/**
 * Custom hook for infinite scrolling
 * @param {Function} fetchNextPage - Function to fetch next page
 * @param {boolean} hasNextPage - Whether there are more pages to load
 * @param {boolean} isFetchingNextPage - Whether currently fetching next page
 * @param {number} threshold - Distance from bottom to trigger load (default: 100px)
 */
export const useInfiniteScroll = (
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  threshold = 100,
) => {
  const handleScroll = useCallback(
    (event) => {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

      if (distanceFromBottom < threshold && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage, threshold],
  );

  return { handleScroll };
};
